<script setup lang="ts">
import SidebarInner from './SidebarInner.vue';

defineProps<{
  collapsed?: boolean
}>()
</script>

<template>
  <SidebarInner />
</template>